import { createContext, useContext } from "react";

// Define the shape of the outlet object
export interface OutletType {
  id: string;
  name: string;
  cartId?: string;
}

// Define the shape of the context data
export interface AddBulkCartContextType {
  userId: string;
  accessToken: string;
  outlets: OutletType[];
  setUserId: (userId: string) => void;
  setAccessToken: (token: string) => void;
  setOutlets: (outlet: OutletType[]) => void;
  resetContext: () => void;
}

// Define the initial state
const initialState: AddBulkCartContextType = {
  userId: "",
  accessToken: "",
  outlets: [],
  setUserId: () => {},
  setAccessToken: () => {},
  setOutlets: () => {},
  resetContext: () => {},
};

// Create the context
const AddBulkCartContext = createContext<AddBulkCartContextType>(initialState);

// Custom hook to use the context
export const useAddBulkCartContext = (): AddBulkCartContextType => {
  const context = useContext(AddBulkCartContext);

  if (!context) {
    throw new Error(
      "useAddBulkCartContext must be used within an AddBulkCartProvider"
    );
  }

  return context;
};

export default AddBulkCartContext;
